import React from "react";
import { Row } from "reactstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import ReactCodeInput from "react-verification-code-input";
import { useTranslation } from "react-i18next";

const Verify = () => {
  const { t, i18n } = useTranslation();
  const initialLoginValues = {
    verifyCode: "",
  };

  const submitLoginForm = (value) => {
    // console.log(value)
  };

  const validationSchemaLogin = Yup.object({
    verifyCode: Yup.string().required(t("کد را وارد کنید.")),
  });

  return (
    <>
      <Row className="justify-content-center flex-column mb-5">
        <h6>{t("تائید شماره موبایل")}</h6>
      </Row>
      <Row className="justify-content-center flex-column text-center">
        <p className="fn10">{t("09121234567 (تغییر شماره)")}</p>
        <p className="fn10 text-muted">
          {t("کد تائید 5 رقمی پیامک شده را در کادر زیر وارد نمائید.")}
        </p>
        <Formik
          initialValues={initialLoginValues}
          onSubmit={submitLoginForm}
          validationSchema={validationSchemaLogin}
        >
          <Form>
            <div className="text-danger fn10 text-center my-2">
              {t("کد وارد شده صحیح نیست.")}
            </div>
            <div>
              <ReactCodeInput name="verifyCode" />
            </div>
            <div className="text-danger fn10 text-center mt-4">
              {t("ارسال مجدد کد (58 ثانیه)")}
            </div>
            <button className="btn btn-primary formBtn mt-4">
              {t("تائید شماره موبایل")}
            </button>
          </Form>
        </Formik>
      </Row>
    </>
  );
};

export { Verify };
